import { API_ROUTE_ADMIN_TELE_POLICIES } from '@/resources/api-routes'
import { post } from '@/util/auth'

import type { SalaryDeductionProfileOriginal } from './type'

const IS_NEW_BACKEND_API = true

export const createTelePolicy = async ({
  payload,
}: {
  payload: Pick<
    SalaryDeductionProfileOriginal,
    'name' | 'telePolicyTemplateId' | 'freeAllowanceAmount' | 'comment'
  > & { global: boolean }
}) => {
  const { salaryDeductionProfile } = await post<{
    salaryDeductionProfile: SalaryDeductionProfileOriginal
  }>(API_ROUTE_ADMIN_TELE_POLICIES, payload, IS_NEW_BACKEND_API)

  return salaryDeductionProfile
}
